import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 md:grid-cols-4 gap-1 w-full px-3 md:px-0" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickWalletDeposit && _ctx.btnClickWalletDeposit(...args))),
      title: "ฝาก"
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("img", {
        class: "",
        src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/bm-1.webp",
        alt: "deposit"
      }, null, -1 /* HOISTED */)
    ])),
    _createElementVNode("li", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickWalletWithdraw && _ctx.btnClickWalletWithdraw(...args))),
      title: "ถอน"
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        class: "",
        src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/bm-2.webp",
        alt: "withdraw"
      }, null, -1 /* HOISTED */)
    ])),
    _createElementVNode("li", {
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickRegister && _ctx.btnClickRegister(...args))),
      title: "สมัครสมาชิก",
      class: "hidden md:block"
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("img", {
        class: "",
        src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/bm-3.webp",
        alt: "register"
      }, null, -1 /* HOISTED */)
    ])),
    _createElementVNode("li", {
      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickContact && _ctx.btnClickContact(...args))),
      title: "ติดต่อ",
      class: "hidden md:block"
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("img", {
        class: "",
        src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/bm-4.webp",
        alt: "contact"
      }, null, -1 /* HOISTED */)
    ]))
  ]))
}